import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { approveLedger, deleteEntry, deleteLedger, downloadExcel, downloadPDF, generateEInvoice, generateEway, getLedgerList, getLedgers, removeCreditNoteItemWiseLedgers, removedPaymentTypeLedgers, updateLedgerEntry, updateNarration, viewCNDNInvoice, viewDispatchInvoice, generateInvoice, importLedgers
// importLedgers // TODO: uncomment once /ledgers/import endpoint is ready
} from '@/api/ledgers';
import Pagination from '@/components/Pagination/index.vue';
import { getDealerById, searchDealers } from '@/api/dealers';
import { getQuery } from '@/utils';
import Inr from '@/components/Inr/index.vue';
import { getAgents, getAgentsBranchWise } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import moment from 'moment';
import { getBranches } from '@/api/locations/branches';
import { BranchAgentService } from '@/services/branch-agent-service';
import { isAdmin, isExcludedToAccess, isPaymentManager, isSuperAdmin } from '@/common';
import { getAdmins } from '@/api/admins';
import * as XLSX from 'xlsx';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.BASE_URL = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.dealerList = [];
    this.agentList = [];
    this.listLoading = false;
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.agentListLoading = false;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.openingBalance = 0;
    this.closingBalance = 0;
    this.isAgent = false;
    this.loggedInAdmin = null;
    this.isReadOnly = false;
    this.isAccountManager = false;
    this.downloadLoading = false;
    this.assignedBranches = [] || null;
    this.isSuperAdmin = false;
    this.isPaymentManager = false;
    this.dialogFormVisible = false;
    this.dialogEditFormVisible = false;
    this.selectedRow = null;
    this.form = {
      comments: '',
      amount: 0
    };
    this.dialogDateFormVisible = false;
    this.dateSaving = false;
    this.selectedRowForDate = null;
    this.dateForm = {
      createdTimestamp: ''
    };
    this.selectedRowForEdit = null;
    this.editForm = {
      amount: 0,
      id: 0,
      dealerId: 0,
      createdTimestamp: '',
      updatedTimestamp: ''
    };
    this.applyFilters = false;
    this.accountManagers = [];
    this.listQuery = {
      page: 1,
      limit: 50,
      dealerId: undefined,
      agentId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      isSuperAdmin: false
    };
    this.query = {
      paymentType: undefined
    };
    // ═══════════════════ IMPORT LEDGER STATE ═══════════════════
    this.importDialogVisible = false;
    this.importPostForm = {
      file: null
    };
    this.importExcelData = [];
    this.showImportWarningDialog = false;
    this.showImportPreview = false;
    this.processingLedgerImport = false;
    this.importProgress = {
      current: 0,
      total: 0
    };
    this.importSuccessCount = 0;
    this.importFailureCount = 0;
    this.importRequiredColumns = ['dealerId', 'dealerName', 'amount', 'entryDate', 'paymentType', 'paymentSubType', 'narration', 'createdBy', 's3url'];
    this.importValidPaymentTypes = ['Credit Note', 'Debit Note', 'Credit Note-Item Wise', 'Debit Note-Item Wise', 'Purchase', 'Credit Note Inward', 'Invoice', 'Payment'];
    // ═════════════════════════════════════════════════════════════
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) startYear--;
        const start = moment([startYear, startMonth, startDay]);
        const end = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) startYear--;
        const start = moment([startYear - 1, startMonth, startDay]);
        const end = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '0-23Days',
      label: '0–23 days ago',
      value: () => {
        const end = moment().subtract(0, 'days');
        const start = moment().subtract(23, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '24-30Days',
      label: '24–30 days ago',
      value: () => {
        const end = moment().subtract(24, 'days');
        const start = moment().subtract(30, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '31-45Days',
      label: '31–45 days ago',
      value: () => {
        const end = moment().subtract(31, 'days');
        const start = moment().subtract(45, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '46-60Days',
      label: '46–60 days ago',
      value: () => {
        const end = moment().subtract(46, 'days');
        const start = moment().subtract(60, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '61-1000Days',
      label: '61+ days ago',
      value: () => {
        const end = moment().subtract(61, 'days');
        const start = moment().subtract(1000, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '0-38Days',
      label: '0–38 days ago',
      value: () => {
        const end = moment().subtract(0, 'days');
        const start = moment().subtract(38, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '39-45Days',
      label: '39–45 days ago',
      value: () => {
        const end = moment().subtract(39, 'days');
        const start = moment().subtract(45, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '46-60DaysNew',
      label: '46–60 days ago',
      value: () => {
        const end = moment().subtract(46, 'days');
        const start = moment().subtract(60, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '61-75Days',
      label: '61–75 days ago',
      value: () => {
        const end = moment().subtract(61, 'days');
        const start = moment().subtract(75, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '0-53Days',
      label: '0–53 days ago',
      value: () => {
        const end = moment().subtract(0, 'days');
        const start = moment().subtract(53, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '54-60Days',
      label: '54–60 days ago',
      value: () => {
        const end = moment().subtract(54, 'days');
        const start = moment().subtract(60, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '61-75DaysExisting',
      label: '61–75 days ago',
      value: () => {
        const end = moment().subtract(61, 'days');
        const start = moment().subtract(75, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '76-90Days',
      label: '76–90 days ago',
      value: () => {
        const end = moment().subtract(76, 'days');
        const start = moment().subtract(90, 'days');
        return {
          start,
          end
        };
      }
    }, {
      key: '91-1000Days',
      label: '91+ days ago',
      value: () => {
        const end = moment().subtract(91, 'days');
        const start = moment().subtract(1000, 'days');
        return {
          start,
          end
        };
      }
    }];
  }
  // ─── NEW: Save date range to localStorage ───────────────────────────────────
  saveDateRangeToStorage() {
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      localStorage.setItem('ledgers_dateRange', JSON.stringify({
        page: 'Ledgers',
        startDate: this.dateRange.start,
        endDate: this.dateRange.end
      }));
    }
  }
  // ─── NEW: Load date range from localStorage ──────────────────────────────────
  loadDateRangeFromStorage() {
    try {
      const saved = localStorage.getItem('ledgers_dateRange');
      if (saved) {
        const {
          startDate,
          endDate
        } = JSON.parse(saved);
        if (startDate && endDate) {
          this.dateRange = {
            start: startDate,
            end: endDate
          };
          return true;
        }
      }
    } catch (e) {
      // If parsing fails, fall through to default
      localStorage.removeItem('ledgers_dateRange');
    }
    return false;
  }
  // ────────────────────────────────────────────────────────────────────────────
  async activated() {
    if (AdminModule.roles.includes('Account Manager')) {
      this.isAccountManager = true;
    }
    this.isPaymentManager = isPaymentManager();
    if (isSuperAdmin()) {
      this.isSuperAdmin = true;
      this.listQuery.isSuperAdmin = this.isSuperAdmin;
    }
    this.loggedInAdmin = AdminModule;
    this.assignedBranches = await BranchAgentService.assignBranchId();
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    // ─── MODIFIED: Restore from localStorage, else use default ───────────────
    const restored = this.loadDateRangeFromStorage();
    if (!restored) {
      this.dateRange = {
        start: this.$moment('2022-04-01').format('YYYY-MM-01 12:00') + ' am',
        end: this.$moment().endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
    }
    // URL query params take highest priority and override everything
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange = {
        start: this.$route.query.startDate,
        end: this.$route.query.endDate
      };
    }
    // ─────────────────────────────────────────────────────────────────────────
    if (AdminModule.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = AdminModule.agentId;
    }
    if (this.$route.query.dealerId) {
      this.listQuery.dealerId = +this.$route.query.dealerId;
      await this.getDealerById(this.listQuery.dealerId);
      await this.getList();
    }
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  get importProgressPercentage() {
    if (!this.importProgress.total) return 0;
    return Math.round(this.importProgress.current / this.importProgress.total * 100);
  }
  async createEInvoice(id = 0) {
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create E-invoice?', 'Create E-invoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEInvoiceResponse = await generateEInvoice(id);
        if (generateEInvoiceResponse && generateEInvoiceResponse.status === 'Success') {
          this.$message({
            message: 'E-invoice created successfully',
            type: 'success'
          });
          this.getList();
        } else {
          this.$message({
            message: `${generateEInvoiceResponse.message}`,
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async createEway(id = 0) {
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create E-Way?', 'Create E-Way', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEwayResponse = await generateEway(id);
        if (generateEwayResponse && generateEwayResponse.status === 'Success') {
          this.$message({
            message: 'E-Way created successfully',
            type: 'success'
          });
          this.getList();
        } else {
          this.$message({
            message: 'Failed to create E-Way',
            type: 'error'
          });
          this.downloadJsonFile(generateEwayResponse.payload, 'eway-payload');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async createInvoice(id = 0) {
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create Invoice?', 'Create Iinvoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEInvoiceResponse = await generateInvoice(id);
        if (generateEInvoiceResponse && generateEInvoiceResponse.status === 'success') {
          this.$message({
            message: 'Invoice created successfully',
            type: 'success'
          });
          this.getList();
        } else {
          this.$message({
            message: `${generateEInvoiceResponse.message}`,
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listLoading = true;
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      } else {
        this.$notify({
          type: 'warning',
          title: 'Warning',
          message: 'Please select a daterange'
        });
        return false;
      }
      if (!this.listQuery.dealerId && !this.listQuery.agentId) {
        this.$notify({
          type: 'warning',
          title: 'Warning',
          message: 'Please select a dealer '
        });
        return false;
      }
      const data = await getLedgerList(this.listQuery);
      this.list = data.data;
      this.total = data.total;
      this.openingBalance = data.openingBalance;
      this.closingBalance = data.closingBalance;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    } finally {
      this.listLoading = false;
    }
  }
  async fetchBranches(superAdmin = true) {
    this.branchListLoading = true;
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    if (superAdmin === false) {
      if (this.listQuery.branchId.length === 0) {
        this.listQuery.branchId = AdminModule.branchIds;
      }
      query.id = this.listQuery.branchId;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    this.branchList = await getBranches(getQuery(query));
    this.branchListLoading = false;
  }
  formatDate(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
    return formattedDate;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        fromDealer: true
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async fetchAgentsBranch(branchId) {
    try {
      if (this.listQuery.branchId === '') {
        branchId = AdminModule.branchIds;
      }
      this.agentList = await getAgentsBranchWise(getQuery({
        enabled: true,
        sort: 'name,ASC',
        branchId
      }));
    } catch (error) {
      console.error(error);
    }
  }
  async getDealerById(dealerId = null) {
    this.dealerListLoading = true;
    const data = await getDealerById(dealerId);
    if (data) {
      this.dealerList = [data];
    }
    this.dealerListLoading = false;
  }
  async getAgentList(query = null) {
    try {
      this.agentList = await getAgents(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleClearBranch() {
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  handleClick(row) {
    if (['Debit Note', 'Debit Note-Item Wise', 'Credit Note', 'Credit Note-Item Wise', 'Credit Note Inward'].includes(row.paymentType)) {
      this.editNarration(row);
    } else {
      this.$message.warning('You cannot edit narration for this payment type.');
    }
  }
  editNarration(row) {
    this.selectedRow = row;
    this.form.comments = row.comments;
    this.form.amount = row.amount;
    this.dialogFormVisible = true;
  }
  async saveNarration() {
    try {
      const data = {
        comments: this.form.comments
      };
      await updateNarration(this.selectedRow.id, data);
      this.$message.success('Narration updated successfully');
      this.dialogFormVisible = false;
      this.selectedRow = null;
      this.getList();
    } catch (error) {
      this.$message.error('Error updating narration');
    }
  }
  openEditDialog(row) {
    if (!row || typeof row.amount === 'undefined') {
      this.$message.error('Invalid ledger data');
      return;
    }
    this.editForm = {
      amount: Number(row.amount) || 0,
      id: row.id,
      dealerId: row.dealerId,
      createdTimestamp: row.createdTimestamp,
      updatedTimestamp: moment().utcOffset('+05:30').format('YYYY-MM-DD HH:mm:ss')
    };
    this.selectedRowForEdit = {
      ...row
    };
    this.dialogEditFormVisible = true;
  }
  async deleteEntry(row) {
    try {
      const confirm = await this.$confirm('Are you sure you want to delete this entry?', 'Confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      if (confirm) {
        const deletedEntry = await deleteEntry(row.id);
        if (deletedEntry) {
          this.$message({
            type: 'success',
            message: 'Entry deleted successfully'
          });
        }
      }
    } catch (error) {
      this.$message.error('Something went wrong while deleting the entry.');
      console.error(error);
    }
  }
  async submitEditDialog() {
    try {
      if (this.editForm.createdTimestamp) {
        this.editForm.createdTimestamp = moment(this.editForm.createdTimestamp).utcOffset('+05:30').set({
          hour: 10,
          minute: 0,
          second: 0,
          millisecond: 0
        }).format('YYYY-MM-DD HH:mm:ss');
      }
      const updatedData = await updateLedgerEntry(this.editForm.id, this.editForm);
      if (updatedData) {
        this.dialogEditFormVisible = false;
        this.$message.success('Ledger updated successfully');
      }
    } catch (error) {
      console.error('Error while submitting edit dialog:', error);
      this.$message.error('Failed to submit changes. Please try again.');
    }
  }
  getFormatedURL(url = null) {
    if (!url) {
      return '#';
    }
    if (!url.startsWith('https://')) {
      if (!url.startsWith('http://')) {
        url = 'https://' + url;
      } else {
        url = url.replace('http://', 'https://');
      }
    }
    return url;
  }
  // ─── MODIFIED: Save date range on every filter/search trigger ────────────────
  async handleFilter() {
    var _AdminModule$branchId;
    this.saveDateRangeToStorage(); // <-- persist on search
    if (this.applyFilters) {
      this.handleAdditionalFilters();
      return;
    }
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      this.getList();
    } else {
      this.getList();
    }
  }
  async handleAdditionalFilters() {
    this.saveDateRangeToStorage(); // <-- persist on search
    if (this.applyFilters) {
      const query = {
        enabled: true,
        adminsRoleId: 6,
        filter: {
          enabled: '$eq',
          adminsRoleId: '$in'
        }
      };
      this.accountManagers = await getAdmins(getQuery(query));
    } else {
      this.query.paymentType = undefined;
      this.getList();
    }
    if (this.query.paymentType.length > 0) {
      this.getListByPaymentType();
    }
  }
  // ─────────────────────────────────────────────────────────────────────────────
  async getListByPaymentType() {
    try {
      let createdTimestamp;
      if (this.dateRange) {
        createdTimestamp = [this.dateRange.start, this.dateRange.end].join(',');
      }
      const ledgerQuery = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        dealerId: this.listQuery.dealerId,
        enabled: true,
        approvalStatus: 'Approved',
        paymentType: this.query.paymentType,
        createdTimestamp: createdTimestamp,
        sort: 'id,ASC',
        filter: {
          enabled: '$eq',
          approvalStatus: '$eq',
          paymentType: 'in',
          dealerId: '$eq',
          createdTimestamp: 'between'
        }
      };
      const data = await getLedgers(getQuery(ledgerQuery));
      this.list = data.data;
      this.total = data.total;
    } catch (error) {
      this.$message.error('Error fetching ledgers by payment type');
    } finally {
      this.listLoading = false;
    }
  }
  async handlePDFDownload() {
    try {
      this.listLoading = true;
      const query = this.listQuery;
      const url = await downloadPDF(query);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate ledger',
          type: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const query = this.listQuery;
      const blob = await downloadExcel(query);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ledgers.xlsx');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      this.downloadLoading = false;
    }
  }
  async handleApplyFiltersExcelDownload() {
    this.downloadLoading = true;
    try {
      let createdTimestamp;
      if (this.dateRange) {
        createdTimestamp = [this.dateRange.start, this.dateRange.end].join(',');
      }
      const ledgerQuery = {
        dealerId: this.listQuery.dealerId,
        enabled: true,
        approvalStatus: 'Approved',
        paymentType: this.query.paymentType,
        createdTimestamp: createdTimestamp,
        sort: 'id,ASC',
        filter: {
          enabled: '$eq',
          approvalStatus: '$eq',
          paymentType: '$in',
          dealerId: '$eq',
          createdTimestamp: 'between'
        }
      };
      const data = await getLedgers(getQuery(ledgerQuery));
      const allData = data;
      if (!allData || allData.length === 0) {
        this.$message.warning('No data found for Excel download');
        return;
      }
      const dealerName = allData[0].dealer.name;
      const mappedData = allData.map(item => {
        var _item$ordersDispatch, _item$transaction, _item$transaction2, _item$transaction3;
        return {
          Date: this.formatDate(item.createdTimestamp),
          Dealer: item.dealer.name,
          Invoice: (item === null || item === void 0 || (_item$ordersDispatch = item.ordersDispatch) === null || _item$ordersDispatch === void 0 ? void 0 : _item$ordersDispatch.invoiceNumber) || `${((_item$transaction = item.transaction) === null || _item$transaction === void 0 ? void 0 : _item$transaction.referenceNumber) || item.paymentType}-${((_item$transaction2 = item.transaction) === null || _item$transaction2 === void 0 ? void 0 : _item$transaction2.paymentMode) || item.transactionReference}`,
          Debit: item.action === 'debit' ? parseFloat(item.amount) : 0,
          Credit: item.action === 'credit' ? parseFloat(item.amount) : 0,
          Narration: (item === null || item === void 0 ? void 0 : item.comments) || ((_item$transaction3 = item.transaction) === null || _item$transaction3 === void 0 ? void 0 : _item$transaction3.comments) || ''
        };
      });
      const newCols = [{
        header: 'Date',
        key: 'Date'
      }, {
        header: 'Dealer',
        key: 'Dealer'
      }, {
        header: 'Invoice',
        key: 'Invoice'
      }, {
        header: 'Debit',
        key: 'Debit'
      }, {
        header: 'Credit',
        key: 'Credit'
      }, {
        header: 'Narration',
        key: 'Narration'
      }];
      const excelHeaders = [{
        text: `${dealerName} Ledgers`,
        bold: true,
        center: true
      }];
      if (this.listQuery.startDate && this.listQuery.endDate) {
        excelHeaders.push({
          text: `From: ${this.formatDate(this.listQuery.startDate)} To: ${this.formatDate(this.listQuery.endDate)}`,
          bold: false,
          center: true
        });
      }
      excelHeaders.push({
        text: ''
      });
      const wb = XLSX.utils.book_new();
      if (mappedData.length > 0) {
        const dataHeaders = Object.keys(mappedData[0]);
        const headerRow = dataHeaders.reduce((acc, key) => {
          acc[key] = key;
          return acc;
        }, {});
        mappedData.unshift(headerRow);
      }
      const customHeaders = excelHeaders.map(header => ({
        Date: header.text
      }));
      const combinedData = customHeaders.concat(mappedData);
      const ws = XLSX.utils.json_to_sheet(combinedData, {
        skipHeader: true
      });
      excelHeaders.forEach((header, index) => {
        const cellAddress = XLSX.utils.encode_cell({
          r: index,
          c: 0
        });
        if (!ws[cellAddress]) {
          ws[cellAddress] = {
            t: 's',
            v: header.text
          };
        }
        ws[cellAddress].s = {
          alignment: {
            horizontal: header.center ? 'center' : 'left',
            vertical: 'center'
          },
          font: {
            bold: header.bold || false
          }
        };
        if (!ws['!merges']) ws['!merges'] = [];
        ws['!merges'].push({
          s: {
            r: index,
            c: 0
          },
          e: {
            r: index,
            c: mappedData[0].length - 1
          }
        });
      });
      ws['!rows'] = excelHeaders.map(() => ({
        hpt: 20
      })).concat(mappedData.map(() => ({
        hpt: 15
      })));
      if (newCols.length > 0) {
        ws['!cols'] = newCols;
      }
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const excelBuffer = XLSX.write(wb, {
        type: 'array',
        bookType: 'xlsx'
      });
      const blob = new Blob([excelBuffer], {
        type: 'application/octet-stream'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${dealerName}-ledgers.xlsx`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      this.downloadLoading = false;
    }
  }
  async viewDispatchInvoice(id) {
    try {
      this.listLoading = true;
      const url = await viewDispatchInvoice(id);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async downloadInvoice(params) {
    try {
      this.listLoading = true;
      if (params.paymentType === 'Credit Note' || params.paymentType === 'Debit Note') {
        const url = await viewCNDNInvoice(params.id);
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$message({
            message: 'Failed to generate invoice',
            type: 'error'
          });
        }
      } else {
        const url = await generateInvoice(params.id);
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$message({
            message: 'Failed to generate invoice',
            type: 'error'
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async rejectCreditTypeLedger(params, index) {
    try {
      this.$confirm('Are you sure you want to reject this ledger?', 'Reject Ledger', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        if (params.action === 'credit') {
          if (params.paymentType === 'Payment') {
            await this.rejectPaymentTypeLedger(params, false);
          } else {
            await removeCreditNoteItemWiseLedgers(params);
          }
        } else {
          await deleteLedger(params.id);
        }
        this.$message({
          message: 'Ledger rejected successfully',
          type: 'success'
        });
        this.getList();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request cancelled'
        });
      });
    } catch (error) {
      this.$message.error('Error Rejecting Ledger');
    }
  }
  async approveCreditTypeLedger(params, index) {
    try {
      this.$confirm('Are you sure you want to approve this ledger?', 'Approve Ledger', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--success',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        params.approvalStatus = 'Approved';
        await approveLedger(params);
        this.$message({
          message: 'Ledger approved successfully',
          type: 'success'
        });
        this.getList();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request cancelled'
        });
      });
    } catch (error) {
      this.$message.error('Error Approving Ledger');
    }
  }
  async rejectPaymentTypeLedger(params, showConfirmation = true) {
    try {
      if (showConfirmation) {
        await this.$confirm('Are you sure you want to reject this ledger?', 'Reject Ledger', {
          confirmButtonText: 'Yes',
          confirmButtonClass: 'el-button--danger',
          cancelButtonText: 'No',
          type: 'error'
        });
      }
      if (params.paymentType === 'Payment') {
        await removedPaymentTypeLedgers(params);
      } else {
        await deleteLedger(params.id);
      }
      if (showConfirmation) {
        this.$message({
          message: 'Ledger rejected successfully',
          type: 'success'
        });
      }
      this.getList();
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error('Error Rejecting Ledger');
      }
    }
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (index === 4) {
        const values = data.map(item => {
          if (item.action === 'debit') {
            return parseFloat(item.amount);
          }
          return 0;
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = parseFloat(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Math.round(sums[index]);
        } else {
          sums[index] = 0;
        }
      } else if (index === 5) {
        const values = data.map(item => {
          if (item.action === 'credit') {
            return parseFloat(item.amount);
          }
          return 0;
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = parseFloat(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Math.round(sums[index]);
        } else {
          sums[index] = 0;
        }
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  async viewPdf(params, showMerged = false) {
    try {
      this.listLoading = true;
      let url;
      if (showMerged) {
        url = params.ledgerAttachmentS3Url;
      } else {
        if (params.paymentType === 'Credit Note' || params.paymentType === 'Debit Note') {
          url = await viewCNDNInvoice(params.id);
        } else {
          url = await generateInvoice(params.id);
        }
      }
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      this.$message({
        message: 'An error occurred while generating the invoice',
        type: 'error'
      });
    } finally {
      this.listLoading = false;
    }
  }
  downloadJsonFile(data, filename) {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}-${new Date().toISOString()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  isCnDnType(row) {
    return ['Credit Note', 'Credit Note-Item Wise', 'Debit Note', 'Debit Note-Item Wise', 'Purchase', 'Credit Note Inward'].includes(row.paymentType);
  }
  hasPdfAttachment(row) {
    return ['Credit Note', 'Credit Note-Item Wise', 'Credit Note Inward', 'Purchase'].includes(row.paymentType) && !!row.ledgerAttachmentS3Url;
  }
  isDirectlyEditable(row) {
    return !['Invoice', 'Credit Note Inward', 'Credit Note-Item Wise', 'Debit Note-Item Wise'].includes(row.paymentType);
  }
  isRouteEditable(row) {
    return ['Credit Note-Item Wise', 'Debit Note-Item Wise', 'Purchase', 'Credit Note Inward'].includes(row.paymentType) && !row.fromTally;
  }
  // ═══════════════════ IMPORT LEDGER METHODS ═══════════════════
  proceedWithImportUpload() {
    this.showImportWarningDialog = false;
    this.$nextTick(() => {
      const uploadComponent = this.$refs.importUploadRef;
      const fileInput = uploadComponent.$el.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.click();
      }
    });
  }
  handleImportFileChange(file, fileList) {
    this.processImportFile(file);
  }
  processImportFile(file) {
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: 'array',
          cellDates: true
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        // header row values map directly onto object keys, so a "createdBy"
        // column header in the sheet lands as row.createdBy automatically
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: undefined,
          defval: null,
          raw: true
        });
        jsonData.forEach((row, index) => {
          var _row$dealerId;
          const rowLabel = `row ${index + 2} (dealerId: ${(_row$dealerId = row.dealerId) !== null && _row$dealerId !== void 0 ? _row$dealerId : 'unknown'})`;
          if (row.entryDate instanceof Date && !isNaN(row.entryDate.getTime())) {
            // Cell was Excel Date-type — meaning Excel already applied its own
            // locale interpretation when this was typed. We cannot know whether
            // that interpretation matches the intended DD/MM/YYYY reading, so
            // we reject it and ask the user to re-enter as Text.
            throw new Error(`${rowLabel}: entryDate cell is formatted as a Date, which means Excel may have ` + 'auto-converted it using your system\'s locale (e.g. MM/DD/YYYY), silently swapping ' + 'day and month. Please re-format the entryDate column as TEXT and re-enter the date ' + 'as DD/MM/YYYY before importing.');
          }
          if (typeof row.entryDate === 'string') {
            const match = row.entryDate.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (!match) {
              throw new Error(`${rowLabel}: Invalid entryDate "${row.entryDate}". Expected format DD/MM/YYYY (e.g. 06/01/2026).`);
            }
            const [, dayStr, monthStr, yearStr] = match;
            const day = +dayStr;
            const month = +monthStr;
            const year = +yearStr;
            if (month < 1 || month > 12) {
              throw new Error(`${rowLabel}: Invalid entryDate "${row.entryDate}". Month value ${month} is out of range (1-12). ` + 'Check that the date is in DD/MM/YYYY order, not MM/DD/YYYY.');
            }
            if (day < 1 || day > 31) {
              throw new Error(`${rowLabel}: Invalid entryDate "${row.entryDate}". Day value ${day} is out of range (1-31).`);
            }
            if (year < 2000 || year > 2100) {
              throw new Error(`${rowLabel}: Invalid entryDate "${row.entryDate}". Year ${year} looks incorrect.`);
            }
            // Normalize to zero-padded DD/MM/YYYY for consistency downstream
            row.entryDate = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
          } else if (row.entryDate !== null && row.entryDate !== undefined) {
            throw new Error(`${rowLabel}: Unsupported entryDate value "${row.entryDate}". Expected text in DD/MM/YYYY format.`);
          }
        });
        if (!this.validateImportExcelStructure(jsonData)) {
          return;
        }
        // Tag each row with its own upload status so the preview table can
        // reflect per-row progress ("Pending" -> "Uploading" -> "Uploaded"/"Failed")
        this.importExcelData = jsonData.map(row => ({
          ...row,
          __status: 'pending',
          __error: ''
        }));
        this.showImportPreview = true;
        this.$message.success(`File validated successfully! ${this.importExcelData.length} rows ready for import.`);
      } catch (error) {
        console.error('Error reading Excel file:', error);
        this.$message.error((error === null || error === void 0 ? void 0 : error.message) || 'Error reading Excel file. Please try again.');
      }
    };
    reader.onerror = () => {
      this.$message.error('Error reading file.');
    };
    reader.readAsArrayBuffer(file.raw);
  }
  validateImportExcelStructure(data) {
    if (data.length === 0) {
      this.$message.error('Excel file is empty!');
      return false;
    }
    const firstRow = data[0];
    const actualColumns = Object.keys(firstRow);
    const missingColumns = this.importRequiredColumns.filter(col => !actualColumns.includes(col));
    if (missingColumns.length > 0) {
      this.$message.error(`Missing required columns: ${missingColumns.join(', ')}`);
      return false;
    }
    const extraColumns = actualColumns.filter(col => !this.importRequiredColumns.includes(col));
    if (extraColumns.length > 0) {
      this.$message.warning(`Excel contains extra columns that will be ignored: ${extraColumns.join(', ')}`);
    }
    const rowsWithoutDealer = data.filter(row => (!row.dealerId || row.dealerId === null) && (!row.dealerName || row.dealerName === null));
    if (rowsWithoutDealer.length > 0) {
      this.$message.error(`Found ${rowsWithoutDealer.length} row(s) without a dealerId or dealerName. Every row must have at least one.`);
      return false;
    }
    const rowsWithBadAmount = data.filter(row => row.amount === null || row.amount === undefined || isNaN(Number(row.amount)) || Number(row.amount) <= 0);
    if (rowsWithBadAmount.length > 0) {
      this.$message.error(`Found ${rowsWithBadAmount.length} row(s) with a missing or invalid amount. All rows must have a positive numeric amount.`);
      return false;
    }
    const rowsWithoutDate = data.filter(row => !row.entryDate || row.entryDate === null);
    if (rowsWithoutDate.length > 0) {
      this.$message.error(`Found ${rowsWithoutDate.length} row(s) without entryDate. All rows must have a valid entry date (DD-MM-YYYY).`);
      return false;
    }
    const rowsWithBadPaymentType = data.filter(row => !row.paymentType || !this.importValidPaymentTypes.includes(row.paymentType));
    if (rowsWithBadPaymentType.length > 0) {
      this.$message.error(`Found ${rowsWithBadPaymentType.length} row(s) with a missing or invalid paymentType. Valid values: ${this.importValidPaymentTypes.join(', ')}.`);
      return false;
    }
    const rowsWithoutCreatedBy = data.filter(row => !row.createdBy || row.createdBy === null);
    if (rowsWithoutCreatedBy.length > 0) {
      this.$message.error(`Found ${rowsWithoutCreatedBy.length} row(s) without createdBy. All rows must specify who created the entry.`);
      return false;
    }
    return true;
  }
  async handleImportSubmit() {
    this.$confirm('This action cannot be reversed. Do you want to proceed with the import?', 'Confirm Import', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(async () => {
      this.processingLedgerImport = true;
      this.importSuccessCount = 0;
      this.importFailureCount = 0;
      this.importProgress = {
        current: 0,
        total: this.importExcelData.length
      };
      const failedRows = [];
      // Send rows to the server ONE AT A TIME instead of dumping the whole
      // array in a single request. Bulk-dumping hundreds of rows in one call
      // was overloading the server; sequential single-row calls keep load
      // predictable and let the UI reflect real-time per-row progress.
      for (let i = 0; i < this.importExcelData.length; i++) {
        const row = this.importExcelData[i];
        Vue.set(row, '__status', 'uploading');
        Vue.set(row, '__error', '');
        try {
          // Strip the UI-only tracking fields before sending to the API
          const {
            __status,
            __error,
            ...cleanRow
          } = row;
          await importLedgers({
            data: [cleanRow]
          });
          Vue.set(row, '__status', 'success');
          this.importSuccessCount++;
        } catch (error) {
          const message = (error === null || error === void 0 ? void 0 : error.message) || String(error) || 'Import failed';
          Vue.set(row, '__status', 'error');
          Vue.set(row, '__error', message);
          this.importFailureCount++;
          failedRows.push({
            index: i,
            dealerId: row.dealerId,
            message
          });
        } finally {
          this.importProgress.current = i + 1;
        }
      }
      this.processingLedgerImport = false;
      if (failedRows.length === 0) {
        this.$message.success(`All ${this.importSuccessCount} row(s) imported successfully!`);
        this.resetImport();
        this.importDialogVisible = false;
      } else {
        this.$message.error(`${this.importSuccessCount} row(s) imported, ${failedRows.length} row(s) failed. ` + 'See the Status column in the preview table for details on each failed row.');
        // Keep the dialog and preview table open so the user can see which
        // rows failed (and why) via the per-row Status column, and can
        // fix/re-upload just those rows if needed.
      }
    }).catch(() => {
      this.$message.info('Import cancelled');
    });
  }
  cancelImport() {
    this.resetImport();
    this.$message.info('Import cancelled');
  }
  resetImport() {
    this.showImportPreview = false;
    this.importExcelData = [];
    this.importPostForm.file = null;
    this.importProgress = {
      current: 0,
      total: 0
    };
    this.importSuccessCount = 0;
    this.importFailureCount = 0;
    const uploadComponent = this.$refs.importUploadRef;
    if (uploadComponent) {
      uploadComponent.clearFiles();
    }
  }
  handleImportFileRemove(file, fileList) {
    this.resetImport();
  }
  handleImportExceed(files, fileList) {
    this.$message.warning('Only one file can be uploaded at a time.');
  }
  // ═════════════════════════════════════════════════════════════
  openDateEditDialog(row) {
    this.selectedRowForDate = row;
    this.dateForm.createdTimestamp = row.createdTimestamp;
    this.dialogDateFormVisible = true;
  }
  async saveDateEdit() {
    try {
      this.dateSaving = true;
      const formattedDate = moment(this.dateForm.createdTimestamp).utcOffset('+05:30').set({
        hour: 10,
        minute: 0,
        second: 0,
        millisecond: 0
      }).format('YYYY-MM-DD HH:mm:ss');
      await updateLedgerEntry(this.selectedRowForDate.id, {
        createdTimestamp: formattedDate
      });
      this.$message.success('Date updated successfully');
      this.dialogDateFormVisible = false;
      this.selectedRowForDate = null;
      this.getList();
    } catch (error) {
      this.$message.error('Error updating date');
    } finally {
      this.dateSaving = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'LedgerList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;